const LOCKED_MESSAGE =
  'Project Connect hanya tersedia untuk agen dengan membership PRO atau EXECUTIVE aktif.';

export const state = () => ({
  loading: false,
  actionLoadingId: null,
  projects: [],
  projectsMeta: null,
  shortlists: [],
  shortlistsMeta: null,
  locked: false,
  error: null,
});

export const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_ACTION_LOADING_ID(state, payload) {
    state.actionLoadingId = payload;
  },
  SET_PROJECTS(state, payload) {
    state.projects = payload;
  },
  SET_PROJECTS_META(state, payload) {
    state.projectsMeta = payload;
  },
  SET_SHORTLISTS(state, payload) {
    state.shortlists = payload;
  },
  SET_SHORTLISTS_META(state, payload) {
    state.shortlistsMeta = payload;
  },
  SET_LOCKED(state, payload) {
    state.locked = payload;
  },
  SET_ERROR(state, payload) {
    state.error = payload;
  },
  REMOVE_PROJECT(state, projectId) {
    state.projects = state.projects.filter((project) => project.id !== projectId);
  },
  REMOVE_SHORTLIST(state, projectId) {
    state.shortlists = state.shortlists.filter((item) => item.project_id !== projectId);
  },
};

function getErrorMessage(error) {
  const response = error && error.response ? error.response : null;
  const data = response && response.data ? response.data : {};

  if (data.errors) return data.errors;
  if (data.error) return data.error;
  if (data.message) return data.message;
  return 'Maaf terjadi kesalahan, silakan coba lagi nanti.';
}

function isLockedError(error) {
  return getErrorMessage(error) === LOCKED_MESSAGE;
}

function getCollectionPayload(data) {
  if (data && data.data && data.data.data !== undefined) {
    return {
      items: data.data.data || [],
      meta: data.data.meta || null,
    };
  }

  return {
    items: data && data.data ? data.data : [],
    meta: data && data.meta ? data.meta : null,
  };
}

function getSinglePayload(data) {
  if (data && data.data && data.data.data !== undefined) {
    return data.data.data;
  }

  if (data && data.data !== undefined) {
    return data.data;
  }

  return data;
}

export const actions = {
  restoreInitialState({ commit }) {
    commit('SET_PROJECTS', []);
    commit('SET_PROJECTS_META', null);
    commit('SET_SHORTLISTS', []);
    commit('SET_SHORTLISTS_META', null);
    commit('SET_LOCKED', false);
    commit('SET_ERROR', null);
    commit('SET_ACTION_LOADING_ID', null);
  },
  async getProjects({ commit, rootState }, page) {
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      commit('SET_LOCKED', false);
      const searchState = rootState.searchListing;
      const { data } = await this.$http.get('/api/project_connect/get_list', {
        params: {
          page: page || 1,
          q: searchState.searchTerm,
          region_ids:
            searchState.selectedRegions && searchState.selectedRegions.length > 0
              ? searchState.selectedRegions.map((value) => value.id)
              : undefined,
          property_type_ids:
            searchState.selectedPropertyTypes && searchState.selectedPropertyTypes.length > 0
              ? searchState.selectedPropertyTypes.map((value) => value.id)
              : undefined,
          min_price: searchState.selectedPriceRange
            ? searchState.selectedPriceRange.min
            : undefined,
          max_price: searchState.selectedPriceRange
            ? searchState.selectedPriceRange.max
            : undefined,
        },
      });
      const payload = getCollectionPayload(data);
      commit('SET_PROJECTS', payload.items);
      commit('SET_PROJECTS_META', payload.meta);
    } catch (error) {
      if (isLockedError(error)) {
        commit('SET_LOCKED', true);
      } else {
        commit('SET_ERROR', getErrorMessage(error));
      }
      commit('SET_PROJECTS', []);
      commit('SET_PROJECTS_META', null);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getShortlists({ commit }, page) {
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      commit('SET_LOCKED', false);
      const { data } = await this.$http.get('/api/project_connect/get_shortlist', {
        params: {
          page: page || 1,
        },
      });
      const payload = getCollectionPayload(data);
      commit('SET_SHORTLISTS', payload.items);
      commit('SET_SHORTLISTS_META', payload.meta);
    } catch (error) {
      if (isLockedError(error)) {
        commit('SET_LOCKED', true);
      } else {
        commit('SET_ERROR', getErrorMessage(error));
      }
      commit('SET_SHORTLISTS', []);
      commit('SET_SHORTLISTS_META', null);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async showContact({ commit }, projectId) {
    try {
      commit('SET_ACTION_LOADING_ID', projectId);
      const { data } = await this.$http.post('/api/project_connect/show_contact', {
        project_id: projectId,
      });
      commit('REMOVE_PROJECT', projectId);
      return getSinglePayload(data);
    } finally {
      commit('SET_ACTION_LOADING_ID', null);
    }
  },
  async removeShortlist({ commit }, projectId) {
    try {
      commit('SET_ACTION_LOADING_ID', projectId);
      await this.$http.post('/api/project_connect/remove_shortlist', {
        project_id: projectId,
      });
      commit('REMOVE_SHORTLIST', projectId);
    } finally {
      commit('SET_ACTION_LOADING_ID', null);
    }
  },
};
